import {
  Inject,
  InjectionToken,
  Optional,
  Pipe,
  PipeTransform,
} from '@angular/core';

import { PolicyIcon } from '@lockton-apps/client-gateway/interfaces';

export type PolicyIconMap = Map<string, { icon: string; iconColor: string }>;

export const POLICY_ICON_MAP = new InjectionToken<PolicyIconMap>(
  'Policy name to icon and icon color map'
);

@Pipe({
  name: 'policyIcon',
  standalone: true,
})
export class PolicyIconPipe implements PipeTransform {
  iconMap: PolicyIconMap;

  transform(value: string): PolicyIcon {
    const backupIcon: { icon: string; iconColor: string } = {
      icon: 'help',
      iconColor: 'grayLight',
    };
    return this.iconMap.get(value) || backupIcon;
  }

  constructor(
    @Optional() @Inject(POLICY_ICON_MAP) policyIconMap: PolicyIconMap
  ) {
    this.iconMap = policyIconMap || new Map();
  }
}
